<template>
  <div style="display: flex;position:relative; color:#000;" @click.stop="toggle">
    <vxe-pulldown ref="pullDown" placement="bottom" transfer style="width:1;">
      <template v-slot:dropdown>
        <div class="my-dropdown3">
          <vxe-table
            auto-resize
            :data="accountList"
            stripe
            show-overflow
            border="none"
            @cell-click="cellClick"
            style="background:#eee;"
            align="center"
          >
            <vxe-table-column field="accountName" title="户名" width="200"></vxe-table-column>
            <vxe-table-column field="bankName" title="开户行" width="200"></vxe-table-column>
            <vxe-table-column field="accountNum" title="账户号" width="200"></vxe-table-column>
          </vxe-table>
        </div>
      </template>
    </vxe-pulldown>
    <span
      style="cursor:pointer;line-height:32px;vertical-algin:middle;display:inline-block;flex:1;color : #2d8cf0 !important;"
    >{{bankName}}</span>
    <Button class="btn-down" icon="ios-arrow-down" style="position:absolute;right:0;top:0;"></Button>
  </div>
</template>

<script>
import $api from "@/apiProvider";
export default {
  name: "UserAccountSelect",

  data() {
    return {
      cate: "",
      compName: "",
      compType: "",
      bankName: "选择银行账户",
      accountList: [],
    };
  },
  methods: {
    async init(compType, userId, compName, cate) {
      this.compType = compType;
      this.userId = userId;
      this.compName = compName;
      this.cate = cate;

      if (this.compName != "") {
        let res;
        if (compType == "platform") {
          res = await $api.platformCorp.post("getPlatformCompanyList", {
            companyName: this.compName,
          });
          this.accountList = res.data;
        } else {
          res = await $api.baseUserSign.post("queryUserBankList", {
            userId: this.userId,
            rows:50
          });
          this.accountList = res.data.rows;
        }

        if (res.status == 1 && this.accountList.length > 0) {
          this.bankName = this.accountList[0].bankName;
          this.$emit("select", this.cate, this.accountList[0]);
        }
      }
    },
    toggle() {
      this.$refs.pullDown.togglePanel();
    },
    cellClick({ row }) {
      this.bankName = row.bankName;
      this.$emit("select", this.cate, row);
      this.toggle();
    },
  },
};
</script>